export const useValidTurnstileTokenCookie = (onVerified?: () => void) => {
  const validTurnstileToken = useCookie('valid-turnstile-token', {
    default: () => false,
  });

  const turnstileToken = ref('');

  const verifyTurnstileToken = async (token: string) => {
    if (!token) {
      return false;
    }

    try {
      const { success } = await $fetch<{ success: boolean }>('/api/verify-turnstile', {
        method: 'GET',
        query: {
          token,
        },
      });

      if (success) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Error verifying turnstile token:', error);
      // nullify the cookie
      validTurnstileToken.value = false;
      return false;
    }
  };

  watch(turnstileToken, async newVal => {
    if (newVal) {
      const isVerified = await verifyTurnstileToken(newVal);
      if (isVerified && onVerified) {
        await nextTick();
        onVerified();
      }
    }
  });

  return {
    validTurnstileToken: readonly(validTurnstileToken),
    turnstileToken,
    verifyTurnstileToken,
  };
};
